<template>
  <div class="report--check-list"
       :class="{ reduce: !showChecklist }">
    <div class="report--check-list--wrap">
      <i class="icon"
         :class="{ 'icon--reduce': showChecklist, 'icon--expand': !showChecklist }"
         @click="onToggleChecklist"></i>
      <button type="button"
              class="title"
              :class="!currentCategory ? 'on' : ''"
              @click="onViewTypeChange('summary')">Side Bar</button>
      <ul class="categories">
        <li v-for="item in swasCategory"
            :key="item.id"
            :class="currentCategory && currentCategory.id === item.id ? 'on' : ''">
          <a href="#" @click.prevent="onCategoryClick(item)">
            <span class="number">{{ item.showId }}</span>
            {{ item.titleEn }}
            <span class="result"
              :class="getCategoryScoreCssClass(item.id)">{{ getCategoryScoreText(item.id) }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'ReportCheckList',
  props: ['currentCategory', 'isSummary', 'summaryMap', 'report', 'showChecklist'],
  computed: {
    ...mapGetters(['swasCategory']),

    needCount () {
      const need = {
        passCount: 0,
        errorCount: 0
      }
      _.each(this.summaryMap, subScore => {
        need.passCount += subScore.criticalPassRule
        need.errorCount += subScore.criticalErrorRule
      })
      return need
    }
  },
  methods: {
    onToggleChecklist () {
      this.$emit('onToggleChecklist')
    },
    onCategoryClick (category) {
      this.$emit('onCategoryClick', category)
    },
    onViewTypeChange (value) {
      this.$emit('onViewTypeChange', value)
    },
    getCategoryScoreText (categoryId) {
      const resultType = this.summaryMap[categoryId].resultType

      switch (resultType) {
        case 'E':
        case 'P':
          return resultType
        default:
          return ''
      }
    },
    getCategoryScoreCssClass (categoryId) {
      const resultType = this.summaryMap[categoryId].resultType

      switch (resultType) {
        case 'E':
          return 'error'
        case 'P':
          return 'pass'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.report--check-list {
  max-height: calc(100%);
  overflow: auto;
  border-radius: 10px;
  box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;

  &.reduce {
    overflow: hidden;

    .title {
      opacity: 0;
    }

    .categories {
      opacity: 0;
    }
  }

  .report--check-list--wrap {
    padding: 5px 12px;
    overflow: hidden;
    position: relative;
  }

  .icon--reduce,
  .icon--expand {
    position: absolute;
    top: 0;
    right: 0;
    width: 35px;
    height: 35px;
    background-size: 14px 14px;
    cursor: pointer;
    z-index: 10;
  }

  .title {
    font-size: 13px;
    color: #5e6bc3;
    transition: opacity 0.3s ease;

    &.on {
    }
  }

  .categories {
    margin: 20px 0;
    transition: opacity 0.3s ease;

    li {
      border-radius: 4px;
      transition: background-color 0.2s ease;

      &.on {
        background-color: rgba(0, 0, 0, 0.08);
      }
    }

    a {
      display: block;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.4;
      letter-spacing: normal;
      color: #555555;
      padding: 6px 30px 6px 22px;
      position: relative;

      .number {
        display: block;
        position: absolute;
        top: 6px;
        left: -8px;
        width: 22px;
        text-align: right;
        line-height: 1.4;
      }

      .result {
        position: absolute;
        top: 6px;
        right: 2px;
        display: block;
        width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        color: #ffffff;
        font-size: 11px;
        border-radius: 10px;
        font-weight: bold;

        &.error {
          background-color: #ec0047;
        }

        &.pass {
          background-color: #3eaa08;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/valid-member/report/ReportCheckList.vue